import { z } from 'zod';
import { currencySchema, isoDateTimeSchema, provinceSchema, uuidSchema } from './common.js';
/**
 * Organisation — the tenant boundary.
 *
 * Today there is exactly one organisation. Every table, policy and API route is
 * nevertheless scoped by `organizationId` from the start, because retrofitting
 * multi-tenancy onto a live financial database is the kind of migration nobody
 * wants to perform on real books.
 */
export const ORGANIZATION_STATUSES = ['active', 'suspended', 'archived'];
export const organizationStatusSchema = z.enum(ORGANIZATION_STATUSES);
export const organizationSchema = z.object({
    id: uuidSchema,
    name: z.string().min(1).max(200),
    /** URL-safe identifier, unique across the platform. */
    slug: z
        .string()
        .min(2)
        .max(60)
        .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/, 'must be lowercase alphanumeric words separated by hyphens'),
    status: organizationStatusSchema,
    province: provinceSchema,
    countryCode: z.literal('CA'),
    /** IANA timezone. Drives which calendar day a transaction belongs to. */
    timezone: z.string().min(1),
    defaultCurrency: currencySchema,
    createdAt: isoDateTimeSchema,
    updatedAt: isoDateTimeSchema,
});
export const createOrganizationRequestSchema = z.object({
    name: z.string().trim().min(1).max(200),
    slug: organizationSchema.shape.slug.optional(),
    province: provinceSchema.default('NB'),
    timezone: z.string().min(1).default('America/Moncton'),
    defaultCurrency: currencySchema.default('CAD'),
});
export const updateOrganizationRequestSchema = z
    .object({
    name: z.string().trim().min(1).max(200),
    province: provinceSchema,
    timezone: z.string().min(1),
    defaultCurrency: currencySchema,
})
    .partial()
    .refine((value) => Object.keys(value).length > 0, {
    message: 'At least one field must be provided.',
});
//# sourceMappingURL=organization.js.map